import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const More = ({
  width = 32,
  height = 32,
  className,
  filled,
  color,
  decorative = false,
  ariaLabel = "More",
}: IconProps) => {
  const classes = createColorClasses({ color });
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 32 32"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      {filled ? (
        <path
          fillRule="evenodd"
          d="M3.167 4c0-.736.596-1.333 1.333-1.333h9.333c.737 0 1.333.597 1.333 1.333v9.334c0 .736-.596 1.333-1.333 1.333H4.5a1.333 1.333 0 0 1-1.333-1.333V4ZM3.167 18.667c0-.736.596-1.333 1.333-1.333h9.333c.737 0 1.333.597 1.333 1.333V28c0 .737-.596 1.334-1.333 1.334H4.5A1.333 1.333 0 0 1 3.167 28v-9.333ZM19.166 2.667c-.736 0-1.333.597-1.333 1.333v9.334c0 .736.597 1.333 1.334 1.333H28.5c.736 0 1.333-.597 1.333-1.333V4c0-.736-.597-1.333-1.333-1.333h-9.334ZM21.689 29.173a.235.235 0 0 0 .43.038l2.654-4.844a.236.236 0 0 1 .093-.094l4.845-2.654a.235.235 0 0 0-.039-.43l-11.529-3.843a.235.235 0 0 0-.297.298l3.843 11.529Zm2.032-5.383-1.593 2.906-2.534-7.601 7.602 2.534-2.906 1.592c-.24.131-.438.329-.57.57Z"
          clipRule="evenodd"
        />
      ) : (
        <path
          fillRule="evenodd"
          d="M3.167 4c0-.736.597-1.333 1.333-1.333h9.333c.737 0 1.334.597 1.334 1.333v9.334c0 .736-.597 1.333-1.334 1.333H4.5a1.333 1.333 0 0 1-1.333-1.333zM4.5 4h9.333v9.334H4.5zM3.167 18.667c0-.736.597-1.333 1.333-1.333h9.333c.737 0 1.334.597 1.334 1.333V28c0 .737-.597 1.334-1.334 1.334H4.5A1.333 1.333 0 0 1 3.167 28zm1.333 0h9.333V28H4.5zM19.167 2.667c-.737 0-1.334.597-1.334 1.333v9.334c0 .736.597 1.333 1.334 1.333H28.5c.736 0 1.333-.597 1.333-1.333V4c0-.736-.597-1.333-1.333-1.333zM28.5 4h-9.333v9.334H28.5zM21.689 29.173a.235.235 0 0 0 .43.038l2.654-4.844a.24.24 0 0 1 .093-.094l4.845-2.654a.235.235 0 0 0-.039-.43l-11.528-3.843a.236.236 0 0 0-.298.298zm2.032-5.383-1.593 2.906-2.534-7.601 7.602 2.534-2.906 1.592c-.24.131-.438.329-.57.57"
          clipRule="evenodd"
        ></path>
      )}
    </svg>
  );
};

